import { render, staticRenderFns } from "./GfBeneficiarySearch.vue?vue&type=template&id=3f403e71&"
import script from "./GfBeneficiarySearch.vue?vue&type=script&lang=js&"
export * from "./GfBeneficiarySearch.vue?vue&type=script&lang=js&"
import style0 from "./GfBeneficiarySearch.vue?vue&type=style&index=0&id=3f403e71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports